<ion-app>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
<app-loader></app-loader> 
